import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA Service Worker - force cleanup of old SW/caches once per bump
const SW_VERSION = 'v3-2026-04-18';
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      if (localStorage.getItem('sw_version') !== SW_VERSION) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map(r => r.unregister()));
        if (window.caches) {
          const keys = await caches.keys();
          await Promise.all(keys.map(k => caches.delete(k)));
        }
        localStorage.setItem('sw_version', SW_VERSION);
      }
      navigator.serviceWorker.register('/service-worker.js').catch(() => {});
    } catch { /* ignore */ }
  });
}
